import { axiosInstance } from '.';

const addBranch = async (payload) => await axiosInstance.post('/branches', payload);

const getBranch = async (id) => await axiosInstance.get(`/branches/${id}`);

const editBranch = async ({ id, data }) => await axiosInstance.put(`/branches/${id}`, data);

const editBranchServices = async ({ id, data }) => await axiosInstance.put(`/branch_services/${id}`, data);

const getAddressFromCoords = async (data) =>
  await axiosInstance.get(`/countries/data?lat=${data?.lat}&lng=${data?.lng}`);

const getBranchServicesList = async (params) => await axiosInstance.get('/branch_services', { params });

const deleteBranchSpecialty = async ({ id }) => await axiosInstance.delete(`/branch_specialties/${id}`);

const deleteBranchService = async ({ id }) => await axiosInstance.delete(`/branch_services/${id}`);

const getBranchesList = async (params) => await axiosInstance.get('/branches', { params });

const deleteBranch = async ({ id }) => await axiosInstance.delete(`/branches/${id}`);

const getBranchReviewsList = async (params) => await axiosInstance.get(`/branch_reviews`, { params });

const deleteBranchReview = async ({ id }) => await axiosInstance.delete(`/branch_reviews/${id}`);

const getBranchReviewDetails = async ({ id }) => await axiosInstance.get(`/branch_reviews/${id}`);

export {
  addBranch,
  getAddressFromCoords,
  getBranch,
  editBranch,
  getBranchServicesList,
  deleteBranchSpecialty,
  editBranchServices,
  deleteBranchService,
  getBranchesList,
  deleteBranch,
  getBranchReviewsList,
  deleteBranchReview,
  getBranchReviewDetails,
};
